import React from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from '../../AppContext';
import NavBar from "../../components/NavBar";
import './receipt.scss';
import {TagIcon} from '../../components/Icons';

import { DateRevivier, Session } from '../../Types';

const Receipt: React.SFC<{}> = () => {

    const context = React.useContext(AppContext);
    let state = context.state;
    let history = useHistory();

    React.useEffect(() => {
        const timer = setTimeout(() => {

            // serialise the updated state so we don't loose anything if the farmer takes a break and app is restarted
            state.previous = { ...state.current};
            state.animals.push({ ...state.current});
            state.current = {
                date: new Date(),
                herd: '',
                tagNumber: 0,
                tailCondition: '',
                activeInjury: false,
                highSevereCount: 0,
                highMildCount: 0,
                midSevereCount: 0,
                midMildCount: 0,
                lowSevereCount: 0,
                lowMildCount: 0,
                dockedPosition: '',
            }
            context.setState(state);

            localStorage.setItem('session', JSON.stringify(state));


            let sessionsJSON = localStorage.getItem("sessions");
            if (sessionsJSON) {
                let tempSessions = JSON.parse(sessionsJSON, DateRevivier ) as Session[];
                let storedSessions: Session[] = [];
                if (!Array.isArray(tempSessions)){
                    storedSessions.push(tempSessions);
                } else {
                    storedSessions = tempSessions;
                }
                
                storedSessions.forEach( (stored) =>{
                    if(state.session_id === stored.session_id) {
                        stored.animals = [...state.animals];
                    }
                });

                localStorage.setItem('sessions', JSON.stringify(storedSessions));
            }

            history.push('/enter_tag');
        }, 750);
        return () => clearTimeout(timer);
      }, []);

    return (
        <>
        <NavBar
        />
    	<div className="content-pane">
            <div className="receipt-pane">
                <TagIcon fill="#FFDD57" />
                <h2>{state.current.tagNumber} </h2>
                <h3>added.</h3>
            </div>

    	</div>
        </>
    )
}

export default Receipt;